import { render, staticRenderFns } from "./Ajustes.vue?vue&type=template&id=1559c06c&"
import script from "./Ajustes.vue?vue&type=script&lang=js&"
export * from "./Ajustes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports